import { Promisify } from '../types/ValidateWith';
import { isPromise } from './isPromise';

const promisify: Promisify = fn => (...params) =>
  new Promise((resolve, reject) => {
    const result = fn(...params);
    if (result) {
      if (isPromise(result)) {
        return result.then(resolve).catch(reject);
      }
      if ((result as {}).hasOwnProperty('errorCode')) {
        return reject(result);
      }
    }

    return resolve();
  });

export { promisify };
